import styled, { css } from 'styled-components';
import { getThemeProp } from 'theme';

export const StyledContainer = styled.div`
  align-items: center;
  border-bottom: 1px solid rgba(144, 151, 168, 0.28);
  break-inside: avoid;
  display: flex;
  justify-content: space-between;
  line-height: 38px;
`;

export const StyledLabel = styled.span`
  color: ${getThemeProp('color.ebonyClayBlue')};
  font-size: 12px;
`;

export const iconOrValueBaseStyles = css`
  color: ${getThemeProp('color.ebonyClayBlue')};
  font-size: 12px;
  font-weight: 700;
  min-width: 50px;
  text-align: right;
  text-transform: uppercase;
`;

export const StyledValue = styled.span`
  ${iconOrValueBaseStyles};
`;

export const StyledIcon = styled.i`
  ${iconOrValueBaseStyles};

  &:before {
    font-size: 21px;
  }
`;
